
// 控制台开启测试模式：https://support.appsflyer.com/hc/en-us/articles/360012729178-Test-PBA-web-SDK-integration
/**
 * 发送AppsFlyer事件
 * 
 * 此函数用于通过AppsFlyer SDK发送自定义事件如果SDK已加载，则发送事件；
 * 否则，输出警告消息到控制台
 * 
 * @param {string} eventName - 要发送的事件名称
 * @param {Object} eventData - 附加的事件数据，默认为空对象
 */
export function sendAppsFlyerEvent(eventName, eventValue = {}) {
    // 检查AppsFlyer SDK是否已加载
    if (window.AF) {
        // 发送事件到AppsFlyer
        window.AF('pba', 'event', {
            eventName,
            eventValue,
            eventType: 'EVENT',
        });
        // 输出发送的事件信息到控制台
        console.log(`AppsFlyer 事件已发送: ${eventName}`, eventValue);
    } else {
        // 如果SDK未加载，输出警告信息到控制台
        console.warn("AppsFlyer SDK 未加载");
    }
}
//转换事件
export function sendAppsFlyerConversionEvent(eventName, eventRevenue = 0, eventRevenueCurrency = 'USD', eventValue = {}) {
    // 检查AppsFlyer SDK是否已加载
    if (window.AF) {
        // 发送事件到AppsFlyer
        window.AF('pba', 'event', {
            eventName,
            eventType: 'EVENT',
            eventRevenue,
            eventRevenueCurrency,
            eventValue
        });
        // 输出发送的事件信息到控制台
        console.log(`AppsFlyer 转换 事件已发送: ${eventName}`, eventValue);
    } else {
        // 如果SDK未加载，输出警告信息到控制台
        console.warn("AppsFlyer SDK 未加载");
    }
}

/**
 * 设置AppsFlyer客户用户ID
 * 
 * 此函数用于通过AppsFlyer SDK设置客户用户ID如果SDK已加载，则设置CUID；
 * 否则，输出警告消息到控制台
 * 
 * @param {string} cuid - 客户用户ID
 */
export function setAppsFlyerCuid(cuid) {
    // 检查AppsFlyer SDK是否已加载
    if (window.AF) {
        // 设置客户用户ID
        window.AF('pba', 'setCustomerUserId', cuid);
        // 输出设置的CUID信息到控制台
        console.log("AppsFlyer CUID 已设置:", cuid);
    } else {
        // 如果SDK未加载，输出警告信息到控制台
        console.warn("AppsFlyer SDK 未加载");
    }
}
/**
 * 获取 afUserId
 * @param {number} delay - 每次重试的间隔时间，单位毫秒
 * @returns {Promise<string|null>} - 返回 afUserId 的 Promise
 */
export function getAppsFlyerUserId() {
    return window.AF_SDK?.utils?.cookie?.get('afUserId') || null;
}
